import {Component, Input, OnInit} from '@angular/core';
import {AppointeeData} from '../../../shared/types/appointment/appointee-data';
import {AddAppointmentService} from '../../../shared/services/appointment/add-appointment.service';
import {ENTRY_STATES} from '../../../shared/types/entry/EntryStatesEnum';
import {Appointment} from '../../../shared/types/person/appointment';

@Component({
  selector: 'wsd-organization-appointees',
  templateUrl: './organization-appointees.component.html',
  styleUrls: ['./organization-appointees.component.css']
})
export class OrganizationAppointeesComponent implements OnInit {

  @Input()
  appointees: AppointeeData[];

  constructor(private addAppointmentService: AddAppointmentService) { }

  ngOnInit() {
    this.initAppointmentList();
  }

  initAppointmentList() {
    //add initial order number
    for (let i = 0; i < this.appointees.length; i++) {
      const appointment = this.appointees[i];
      if (!appointment.orderNumber) {
        appointment.orderNumber = i;
      }
    }

    this.appointees.sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1));

    //fix missing order number
    for (let i = 0; i < this.appointees.length; i++) {
      const appointment = this.appointees[i];
      if (appointment.orderNumber != i) {
        appointment.orderNumber = i;
      }
    }
  }

  moveAppointmentUp(appointment: AppointeeData) {
    const originIndex = appointment.orderNumber;
    const newIndex = originIndex - 1;
    appointment.orderNumber = newIndex;
    this.appointees[newIndex].orderNumber = originIndex;
    this.appointees.sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1));
  }

  moveAppointmentDown(appointment: AppointeeData) {
    const originIndex = appointment.orderNumber;
    const newIndex = originIndex + 1;
    appointment.orderNumber = newIndex;
    this.appointees[newIndex].orderNumber = originIndex;
    this.appointees.sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1));
  }

  add() {
    this.addAppointmentService.create();
  }

  modify(appointee: AppointeeData) {
    this.addAppointmentService.modify(appointee);
  }

  delete(appointee: AppointeeData) {
    this.appointees.splice(this.appointees.indexOf(appointee), 1);
  }

  onSave(event) {
    if (event.$state === ENTRY_STATES.NEW) {
      event.orderNumber = this.appointees.length;
      this.appointees.push(event);
    }
  }

  getFullName(appointee: AppointeeData): string {
    let name: string = '';
    if (appointee.consultant.firstName) {
      name = appointee.consultant.firstName + ' ';
    }
    if (appointee.consultant.lastName) {
      name += appointee.consultant.lastName;
    }
    return name;
  }

}
